/** Saves text as a file through a temporary link. */
export function downloadText(text: string, fileName: string, type = 'text/csv') {
  downloadBlob(new Blob([text], { type: `${type};charset=utf-8` }), fileName);
}

/** Saves a file (a CSV, an export from the API) through a temporary link. */
export function downloadBlob(blob: Blob, fileName: string) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
}
